// Legacy hooks - maintained for backward compatibility
// New code should use the enhanced hooks from useContentQueries and useSearchQueries

import {
  useFeaturedContent as useEnhancedFeaturedContent,
  useMovies as useEnhancedMovies,
  useTVShows as useEnhancedTVShows,
  useContentDetails as useEnhancedContentDetails,
  useGenres as useEnhancedGenres,
} from './useContentQueries';

import {
  useSearchContent as useEnhancedSearchContent,
} from './useSearchQueries';

// Re-export enhanced hooks with legacy names for backward compatibility
export const useFeaturedContent = () => {
  return useEnhancedFeaturedContent();
};

export const useMovies = (page = 1, limit = 20, filters?: { genre?: string; year?: number; yearFrom?: number; yearTo?: number; includePeople?: boolean }) => {
  return useEnhancedMovies(page, limit, filters);
};

export const useTVShows = (page = 1, limit = 20, filters?: { genre?: string; year?: number; yearFrom?: number; yearTo?: number; includePeople?: boolean }) => {
  return useEnhancedTVShows(page, limit, filters);
};

export const useContentDetails = (id: string) => {
  return useEnhancedContentDetails(id);
};

export const useSearchContent = (query: string, page = 1, limit = 20) => {
  return useEnhancedSearchContent(query, page, limit);
};

export const useGenres = () => {
  return useEnhancedGenres();
};

// Export a combined hook for convenience
export const useContent = {
  featured: useFeaturedContent,
  movies: useMovies,
  tvShows: useTVShows,
  details: useContentDetails,
  search: useSearchContent,
  genres: useGenres,
};